import { describeDbError, getSupabase } from '@/lib/supabase'

export type NotificationKind = 'mencao' | 'atribuicao' | 'chamado' | 'conclusao' | 'compartilhamento'

export const NOTIFICATION_KINDS: readonly NotificationKind[] = ['mencao', 'atribuicao', 'chamado', 'conclusao', 'compartilhamento']

/** Rótulo da aba (plural) e do selo do item (singular). */
export const NOTIFICATION_KIND_LABEL: Record<NotificationKind, { tab: string; item: string }> = {
  mencao: { tab: 'Menções', item: 'Menção' },
  atribuicao: { tab: 'Atribuições', item: 'Atribuição' },
  chamado: { tab: 'Chamados', item: 'Chamado' },
  conclusao: { tab: 'Conclusões', item: 'Conclusão' },
  compartilhamento: { tab: 'Compartilhadas', item: 'Nota compartilhada' },
}

export interface HubNotification {
  readonly id: string
  readonly kind: NotificationKind
  readonly title: string
  readonly body: string | null
  /** Rota interna do Hub; o banco recusa qualquer coisa que não comece com "/". */
  readonly link: string | null
  readonly actorId: string | null
  readonly createdAt: string
  readonly readAt: string | null
}

interface NotificationRow {
  id: string
  kind: NotificationKind
  title: string
  body: string | null
  link: string | null
  actor_id: string | null
  created_at: string
  read_at: string | null
}

export type NotificationsResult<T> = { ok: true; data: T } | { ok: false; reason: string }

/** As mais recentes primeiro. O RLS já recorta: só as da própria pessoa chegam. */
export async function fetchNotifications(limit = 100): Promise<NotificationsResult<HubNotification[]>> {
  const { data, error } = await getSupabase()
    .from('notification')
    .select('id, kind, title, body, link, actor_id, created_at, read_at')
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) return { ok: false, reason: describeDbError(error, 'Não foi possível carregar as notificações.') }
  return {
    ok: true,
    data: ((data ?? []) as NotificationRow[]).map((r) => ({
      id: r.id,
      kind: r.kind,
      title: r.title,
      body: r.body,
      link: r.link,
      actorId: r.actor_id,
      createdAt: r.created_at,
      readAt: r.read_at,
    })),
  }
}

/** Marca as indicadas, ou todas (sem ids), como lidas. */
export async function markNotificationsRead(ids?: readonly string[]): Promise<NotificationsResult<number>> {
  const { data, error } = await getSupabase().rpc('mark_notifications_read', {
    p_ids: ids ? [...ids] : null,
  })
  if (error) return { ok: false, reason: describeDbError(error, 'Não foi possível marcar como lida.') }
  return { ok: true, data: Number(data ?? 0) }
}
